export const formatter = new Intl.NumberFormat('en-CA', {
    style: 'currency',
    currency: 'CAD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
})
export const formatterFR = new Intl.NumberFormat('fr-CA', {
    style: 'currency',
    currency: 'CAD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
})
export const formatCAD = (amounts: number, language: number) => {
    return language === 0
        ? formatter.format(amounts)
        : formatterFR.format(amounts)
}
